import { Context } from "./Context";
var DefferTouchResContextID = 0;
export class DefferTouchResContext extends Context {
    constructor() {
        super(...arguments);
        this.cache = null;
        this.mustTouchRes = [];
        this.randomTouchRes = [];
        this.genID = DefferTouchResContextID++;
    }
    touchRes(res) {
        if (res.isRandomTouch) {
            this.randomTouchRes.push(res);
        }
        else {
            this.mustTouchRes.push(res);
        }
    }
}
